module.exports = __webpack_public_path__ + "static/media/76_galvanized_steel_metal_seamless.f56beff1.jpg";